import * as actions from "./Type";
import Instance from "../util/Instance";
import setToken from "../util/SetToken";
import "react-toastify/dist/ReactToastify.css";

export const Get_List_Rent_Contracts = (aid) => {
  return async (dispatch) => {
    if (localStorage.token_GPC_admin) {
      setToken(localStorage.getItem("token_GPC_admin"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      const res = await Instance.get(
        `/api/v1/getRentAgentContractRE/${aid}`,
        config
      );
      dispatch({
        type: actions.GET_RENT_CONTRACTS,
        payload: res.data.data,
      });
    } catch (error) {}
  };
};
export const View_Rent_Contract = (cid) => {
  return async (dispatch) => {
    if (localStorage.token_GPC_admin) {
      setToken(localStorage.getItem("token_GPC_admin"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      const res = await Instance.get(`/api/v1/getRentContract/${cid}`, config);
      dispatch({
        type: actions.VIEW_CONTRACT_RENT,
        payload: res.data.data,
      });
    } catch (error) {}
  };
};
export const Get_List_Sell_Contracts = (aid) => {
  return async (dispatch) => {
    if (localStorage.token_GPC_admin) {
      setToken(localStorage.getItem("token_GPC_admin"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      const res = await Instance.get(
        `/api/v1/getAgentContractRE/${aid}`,
        config
      );
      dispatch({
        type: actions.GET_SELL_CONTRACTS,
        payload: res.data.data,
      });
    } catch (error) {}
  };
};
export const View_Sell_Contract = (id) => {
  return async (dispatch) => {
    if (localStorage.token_GPC_admin) {
      setToken(localStorage.getItem("token_GPC_admin"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      const res = await Instance.get(`/api/v1/getContract/${id}`, config);
      dispatch({
        type: actions.VIEW_CONTRACT_SELL,
        payload: res.data.data,
      });
    } catch (error) {}
  };
};
export const Get_List_Tanents = () => {
  return async (dispatch) => {
    if (localStorage.token_GPC_admin) {
      setToken(localStorage.getItem("token_GPC_admin"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      const res = await Instance.get(`/api/v1/getTenantsDatePayRE`, config);
      if (res.data.status === true) {
        dispatch({
          type: actions.GET_LIST_OF_TANENTS,
          payload: res.data.data,
          tenant_status: true,
        });
      }
    } catch (error) {}
  };
};
export const View_Take_Money = (id) => {
  return async (dispatch) => {
    if (localStorage.token_GPC_admin) {
      setToken(localStorage.getItem("token_GPC_admin"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      const res = await Instance.get(`/api/v1/getWasl/${id}`, config);
      dispatch({
        type: actions.TAKE_MONEY_VIEW,
        payload: res.data.data,
      });
    } catch (error) {}
  };
};
export const View_Each_Recontract = (tid) => {
  return async (dispatch) => {
    if (localStorage.token_GPC_admin) {
      setToken(localStorage.getItem("token_GPC_admin"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      const res = await Instance.get(`/api/v1/getRentContract/${tid}`, config);
      dispatch({
        type: actions.VIEW_RECONTRACT,
        payload: res.data.data,
      });
    } catch (error) {}
  };
};
export const Get_List_Each_Tenant = (tid) => {
  return async (dispatch) => {
    if (localStorage.token_GPC_admin) {
      setToken(localStorage.getItem("token_GPC_admin"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      const res = await Instance.get(
        `/api/v1/getCOntractRentTenant/${tid}`,
        config
      );
      dispatch({
        type: actions.GET_EACH_TENANT_LIST,
        payload: res.data.data,
      });
    } catch (error) {}
  };
};
export const Get_List_Each_Take_Money = (tid) => {
  return async (dispatch) => {
    if (localStorage.token_GPC_admin) {
      setToken(localStorage.getItem("token_GPC_admin"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      const res = await Instance.get(`/api/v1/TenantsWasl/${tid}`, config);
      dispatch({
        type: actions.TAKE_EACH_MONEY_LIST,
        payload: res.data.data,
      });
    } catch (error) {}
  };
};
// export const Get_List_All_Bills = () => {
//   return async (dispatch) => {
//     if (localStorage.token_GPC_admin) {
//       setToken(localStorage.getItem("token_GPC_admin"));
//     }
//     const config = {
//       "content-type": "application/json",
//     };
//     try {
//       const res = await Instance.get(`/api/v1/getAllRECombine`, config);
//       if (res.data.status === true) {
//         dispatch({
//           type: actions.GET_LIST_BILLS_ALL,
//           payload: res.data.data,
//           all_bill__status: true,
//         });
//       }
//     } catch (error) {}
//   };
// };

export const Get_List_Bills = () => {
  return async (dispatch) => {
    if (localStorage.token_GPC_admin) {
      setToken(localStorage.getItem("token_GPC_admin"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      const res = await Instance.get(`/api/v1/ListWaslsRE`, config);
      if (res.data.status === true) {
        dispatch({
          type: actions.GET_LIST_BILLS,
          payload: res.data.data,
          takemoney_status: true,
        });
      }
    } catch (error) {}
  };
};

export const Get_List_Paradan = () => {
  return async (dispatch) => {
    if (localStorage.token_GPC_admin) {
      setToken(localStorage.getItem("token_GPC_admin"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      const res = await Instance.get(`/api/v1/ListOfParadan`, config);
      if (res.data.status === true) {
        dispatch({
          type: actions.GET_LIST_PARADAN,
          payload: res.data.data,
          paradan_status: true,
        });
      }
    } catch (error) {}
  };
};

export const Get_List_Scurity = () => {
  return async (dispatch) => {
    if (localStorage.token_GPC_admin) {
      setToken(localStorage.getItem("token_GPC_admin"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      const res = await Instance.get(`/api/v1/ListOfAsaysh`, config);
      if (res.data.status === true) {
        dispatch({
          type: actions.GET_LIST_ASAYESH,
          payload: res.data.data,
          scurety_status: true,
        });
      }
    } catch (error) {}
  };
};
// export const All_Bills_View = (id) => {
//   return async (dispatch) => {
//     if (localStorage.token_GPC_admin) {
//       setToken(localStorage.getItem("token_GPC_admin"));
//     }
//     const config = {
//       "content-type": "application/json",
//     };
//     try {
//       const res = await Instance.get(`/api/v1/GetViewCombine/${id}`, config);
//       dispatch({
//         type: actions.VIEW_ALL_BILLS,
//         payload: res.data.data,
//       });
//     } catch (error) {}
//   };
// };
export const Take_Money_View = (id, index) => {
  return async (dispatch) => {
    if (localStorage.token_GPC_admin) {
      setToken(localStorage.getItem("token_GPC_admin"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      const res = await Instance.get(`/api/v1/getWasl/${id}`, config);
      dispatch({
        type: actions.VIEW_TAKE_MONEY,
        payload: res.data.data,
        index_all_takemoney: index,
      });
    } catch (error) {}
  };
};
export const View_Paradan = (id, index) => {
  return async (dispatch) => {
    if (localStorage.token_GPC_admin) {
      setToken(localStorage.getItem("token_GPC_admin"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      const res = await Instance.get(`/api/v1/getParadan/${id}`, config);
      dispatch({
        type: actions.PARADAN_VIEW,
        payload: res.data.data,
        index_all_paradan: index,
      });
    } catch (error) {}
  };
};
export const View_Scurety = (id) => {
  return async (dispatch) => {
    if (localStorage.token_GPC_admin) {
      setToken(localStorage.getItem("token_GPC_admin"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      const res = await Instance.get(`/api/v1/getAsaysh/${id}`, config);
      dispatch({
        type: actions.SCURETY_VIEW,
        payload: res.data.data,
      });
    } catch (error) {}
  };
};

export const Get_List_All_Sell_Contracts = () => {
  return async (dispatch) => {
    if (localStorage.token_GPC_admin) {
      setToken(localStorage.getItem("token_GPC_admin"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      const res = await Instance.get(`/api/v1/ContractSale`, config);
      if (res.data.status === true) {
        dispatch({
          type: actions.GET_ALL_SELL_CONTRACTS,
          payload: {
            doc: res.data.data,
          },
          S_status: true,
        });
      }
    } catch (error) {}
  };
};
export const Get_List_All_Sell_Contracts_Failed = () => {
  return async (dispatch) => {
    if (localStorage.token_GPC_admin) {
      setToken(localStorage.getItem("token_GPC_admin"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      const res = await Instance.get(`/api/v1/getRejectedContracts`, config);
      if (res.data.status === true) {
        dispatch({
          type: actions.GET_ALL_SELL_CONTRACTS_FAILED,
          payload: {
            doc: res.data.data,
          },
          S_status_failed: true,
        });
      }
    } catch (error) {}
  };
};

export const Get_List_All_Rent_Contracts = () => {
  return async (dispatch) => {
    if (localStorage.token_GPC_admin) {
      setToken(localStorage.getItem("token_GPC_admin"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      const res = await Instance.get(`/api/v1/getRentREContract`, config);
      if (res.data.status === true) {
        dispatch({
          type: actions.GET_ALL_RENT_CONTRACTS,
          payload: {
            doc: res.data.data,
          },
          R_status: true,
        });
      }
    } catch (error) {}
  };
};
export const Get_List_All_Rent_Contracts_Failed = () => {
  return async (dispatch) => {
    if (localStorage.token_GPC_admin) {
      setToken(localStorage.getItem("token_GPC_admin"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      const res = await Instance.get(
        `/api/v1/getRentRejectedContracts`,
        config
      );
      if (res.data.status === true) {
        dispatch({
          type: actions.GET_ALL_RENT_CONTRACTS_FAILED,
          payload: {
            doc: res.data.data,
          },
          R_status_failed: true,
        });
      }
    } catch (error) {}
  };
};

export const View_All_Sell_Contract = (id, index) => {
  return async (dispatch) => {
    if (localStorage.token_GPC_admin) {
      setToken(localStorage.getItem("token_GPC_admin"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      const res = await Instance.get(`/api/v1/getContract/${id}`, config);
      dispatch({
        type: actions.VIEW_ALL_CONTRACT_SELL,
        payload: res.data.data,
        index_all_sell: index,
      });
    } catch (error) {}
  };
};

export const View_All_Rent_Contract = (id, index) => {
  return async (dispatch) => {
    if (localStorage.token_GPC_admin) {
      setToken(localStorage.getItem("token_GPC_admin"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      const res = await Instance.get(`/api/v1/getRentContract/${id}`, config);
      dispatch({
        type: actions.VIEW_ALL_CONTRACT_RENT,
        payload: res.data.data,
        index_all_rent: index,
      });
    } catch (error) {}
  };
};
// Delete Parawargrtn
export const TakeMoney_Delete_Status = (id, status) => {
  return async (dispatch) => {
    if (localStorage.token_GPC_admin) {
      setToken(localStorage.getItem("token_GPC_admin"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      await Instance.put(
        `/api/v1/deletWaslWithNote/${id}?status=${status}`,
        config
      );
      dispatch({ type: actions.DELETE_TAKEMONEY, id: id });
    } catch (error) {}
  };
};
// export const AllBills_Delete_Status = (id) => {
//   return async (dispatch) => {
//     if (localStorage.token_GPC_admin) {
//       setToken(localStorage.getItem("token_GPC_admin"));
//     }
//     const config = {
//       "content-type": "application/json",
//     };
//     try {
//       await Instance.delete(`/api/v1/deleteCombine/${id}`, config);
//       dispatch({ type: actions.DELETE_BILL, id: id });
//     } catch (error) {}
//   };
// };
// Delete Paradan
export const Paradan_Delete_Status = (id, status) => {
  return async (dispatch) => {
    if (localStorage.token_GPC_admin) {
      setToken(localStorage.getItem("token_GPC_admin"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      await Instance.put(
        `/api/v1/deletParadanWithNote/${id}?status=${status}`,
        config
      );
      dispatch({ type: actions.DELETE_PARADAN, id: id });
    } catch (error) {}
  };
};

/// Delete with out note
export const Sell_Delete_Status = (id, status) => {
  return async (dispatch) => {
    if (localStorage.token_GPC_admin) {
      setToken(localStorage.getItem("token_GPC_admin"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      await Instance.delete(
        `/api/v1/deleteContract/${id}?status=${status}`,
        config
      );

      dispatch({ type: actions.DELETE_SELL, sell_id: id });
    } catch (error) {}
  };
};

export const Rent_Delete_Status = (id, status) => {
  return async (dispatch) => {
    if (localStorage.token_GPC_admin) {
      setToken(localStorage.getItem("token_GPC_admin"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      await Instance.delete(
        `/api/v1/deleteRentContract/${id}?status=${status}`,
        config
      );
      dispatch({ type: actions.DELETE_RENT, rent_id: id });
    } catch (error) {}
  };
};
export const Get_List_Kryar_Bills = () => {
  return async (dispatch) => {
    if (localStorage.token_GPC_admin) {
      setToken(localStorage.getItem("token_GPC_admin"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      const res = await Instance.get(`/api/v1/ListOfProjectSupport`, config);
      dispatch({
        type: actions.GET_PROJECT_BILLS,
        payload: res.data.data,
        S_project_status: true,
      });
    } catch (error) {}
  };
};

export const View_Bill_Anket_Kryar = (projectsupportID, index) => {
  return async (dispatch) => {
    if (localStorage.token_GPC_admin) {
      setToken(localStorage.getItem("token_GPC_admin"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      const res = await Instance.get(
        `/api/v1/getProjectSupport/${projectsupportID}`,
        config
      );
      dispatch({
        type: actions.VIEW_PROJECT_BILLS,
        payload: res.data.data,
        obj: index,
      });
    } catch (error) {}
  };
};

export const Get_List_Vella_Contracts = () => {
  return async (dispatch) => {
    if (localStorage.token_GPC_admin) {
      setToken(localStorage.getItem("token_GPC_admin"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      const res = await Instance.get(`/api/v1/getViellacontractsRE`, config);

      dispatch({
        type: actions.GET_VELLA_CONTRACTS,
        payload: res.data.data,
      });
    } catch (error) {}
  };
};

export const View_Vella_Contract = (id) => {
  return async (dispatch) => {
    if (localStorage.token_GPC_admin) {
      setToken(localStorage.getItem("token_GPC_admin"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      const res = await Instance.get(`/api/v1/getContract/${id}`, config);

      dispatch({
        type: actions.VIEW_CONTRACT_VELLA,
        payload: res.data.data,
        ViellaId: res.data.data.ViellaId,
        branchId: res.data.data.branchId,
      });
    } catch (error) {}
  };
};

// Update Pswlakan
export const Update_Paradan = (id, data) => {
  return async (dispatch) => {
    if (localStorage.token_GPC_admin) {
      setToken(localStorage.getItem("token_GPC_admin"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      await Instance.put(`/api/v1/UpadatParadan/${id}`, { ...data }, config);
      dispatch({ type: actions.UPDATE_PARADAN });
    } catch (error) {}
  };
};
export const Update_TakeMoney = (id, data) => {
  return async (dispatch) => {
    if (localStorage.token_GPC_admin) {
      setToken(localStorage.getItem("token_GPC_admin"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      await Instance.put(`/api/v1/updateWasl/${id}`, { ...data }, config);
      dispatch({ type: actions.UPDATE_TAKEMONEY });
    } catch (error) {}
  };
};
// update all bill
// export const Update_All_Bill = (id, data) => {
//   return async (dispatch) => {
//     if (localStorage.token_GPC_admin) {
//       setToken(localStorage.getItem("token_GPC_admin"));
//     }
//     const config = {
//       "content-type": "application/json",
//     };
//     try {
//       await Instance.put(`/api/v1/UpdateCombine/${id}`, { ...data }, config);
//       dispatch({ type: actions.UPDATE_ALL_BILLS });
//     } catch (error) {}
//   };
// };
export const Update_SellContract = (id, data) => {
  return async (dispatch) => {
    if (localStorage.token_GPC_admin) {
      setToken(localStorage.getItem("token_GPC_admin"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      await Instance.put(`/api/v1/updateContract/${id}`, { ...data }, config);
      dispatch({ type: actions.UPDATE_SELL_CONTRACT });
    } catch (error) {}
  };
};

export const Update_RentContract = (id, data) => {
  return async (dispatch) => {
    if (localStorage.token_GPC_admin) {
      setToken(localStorage.getItem("token_GPC_admin"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      await Instance.put(
        `/api/v1/updateRentContract/${id}`,
        { ...data },
        config
      );
      dispatch({ type: actions.UPDATE_RENT_CONTRACT });
    } catch (error) {}
  };
};

/// tenant

export const Tenant_View_takeMoney = (tid) => {
  return async (dispatch) => {
    if (localStorage.token_GPC_admin) {
      setToken(localStorage.getItem("token_GPC_admin"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      const res = await Instance.get(`/api/v1/TenantsWasl/${tid}`, config);

      dispatch({
        type: actions.VIEW_TENANT_TAKYMONEY,
        payload: res.data.data,
        id_tenant: tid,
      });
    } catch (error) {}
  };
};

export const Tenant_View_Paradan = (tid) => {
  return async (dispatch) => {
    if (localStorage.token_GPC_admin) {
      setToken(localStorage.getItem("token_GPC_admin"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      const res = await Instance.get(
        `/api/v1/getParadansTenant/${tid}`,
        config
      );

      dispatch({
        type: actions.VIEW_TENANT_PARADAN,
        payload: res.data.data,
        id_tenant_paradan: tid,
      });
    } catch (error) {}
  };
};

export const Tenant_View_Contracts = (tid) => {
  return async (dispatch) => {
    if (localStorage.token_GPC_admin) {
      setToken(localStorage.getItem("token_GPC_admin"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      const res = await Instance.get(
        `/api/v1/getCOntractRentTenant/${tid}`,
        config
      );

      dispatch({
        type: actions.VIEW_TENANT_CONTRACTS,
        payload: res.data.data,
      });
    } catch (error) {}
  };
};

export const Tenant_Delete_Status = (id, data) => {
  return async (dispatch) => {
    if (localStorage.token_GPC_admin) {
      setToken(localStorage.getItem("token_GPC_admin"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      await Instance.delete(`/api/v1/deleteTenant/${id}`, { ...data }, config);
      dispatch({ type: actions.DELETE_TENANTS });
    } catch (error) {}
  };
};

// get list writors
export const Get_List_Writors = () => {
  return async (dispatch) => {
    if (localStorage.token_GPC_admin) {
      setToken(localStorage.getItem("token_GPC_admin"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      const res = await Instance.get(`/api/v1/getWritingsRE`, config);
      dispatch({
        type: actions.GET_WRITERS_LIST,
        payload: res.data.data,
      });
    } catch (error) {}
  };
};

// update writer
export const Update_Writer = (id, data) => {
  return async (dispatch) => {
    if (localStorage.token_GPC_admin) {
      setToken(localStorage.getItem("token_GPC_admin"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      await Instance.put(
        `/api/v1/UpdateWritingById/${id}`,
        { ...data },
        config
      );
      dispatch({ type: actions.WRITER_UPDATE });
    } catch (error) {}
  };
};

// Delete writer
export const Delete_Writer = (id, data) => {
  return async (dispatch) => {
    if (localStorage.token_GPC_admin) {
      setToken(localStorage.getItem("token_GPC_admin"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      await Instance.delete(`/api/v1/deleteWriting/${id}`, { ...data }, config);
      dispatch({ type: actions.DELETE_WRITER });
    } catch (error) {}
  };
};

// view Writer
export const View_Writer = (id) => {
  return async (dispatch) => {
    if (localStorage.token_GPC_admin) {
      setToken(localStorage.getItem("token_GPC_admin"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      const res = await Instance.get(`/api/v1/getWriting/${id}`, config);
      dispatch({
        type: actions.VIEW_WRITORS,
        payload: res.data.data,
      });
    } catch (error) {}
  };
};

// Delete Asaysh
export const Scurety_Delete = (id, data) => {
  return async (dispatch) => {
    if (localStorage.token_GPC_admin) {
      setToken(localStorage.getItem("token_GPC_admin"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      await Instance.delete(`/api/v1/deleteAsaysh/${id}`, { ...data }, config);
      dispatch({ type: actions.SCURETY_DELETE });
    } catch (error) {}
  };
};

// Update Scurety Bill
export const Update_ScuretyBill = (id, data) => {
  return async (dispatch) => {
    if (localStorage.token_GPC_admin) {
      setToken(localStorage.getItem("token_GPC_admin"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      await Instance.put(`/api/v1/updateAsaysh/${id}`, { ...data }, config);
      dispatch({ type: actions.SCURITY_UPDATE });
    } catch (error) {}
  };
};

// Delete List Bills
export const Delete_List_All_Sell_Contracts = () => {
  return async (dispatch) => {
    if (localStorage.token_GPC_admin) {
      setToken(localStorage.getItem("token_GPC_admin"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      const res = await Instance.get(`/api/v1/saledeleted`, config);
      if (res.data.status === true) {
        dispatch({
          type: actions.GET_ALL_SELL_CONTRACTS_DELETE,
          payload: res.data.data,
          S_delete_status: true,
        });
      }
    } catch (error) {}
  };
};

export const Delete_List_All_Rent_Contracts = () => {
  return async (dispatch) => {
    if (localStorage.token_GPC_admin) {
      setToken(localStorage.getItem("token_GPC_admin"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      const res = await Instance.get(`/api/v1/rentdeleted`, config);
      if (res.data.status === true) {
        dispatch({
          type: actions.GET_ALL_RENT_CONTRACTS_DELETE,
          payload: res.data.data,
          R_delete_status: true,
        });
      }
    } catch (error) {}
  };
};
export const Delete_List_All_Tenants_Contracts = () => {
  return async (dispatch) => {
    if (localStorage.token_GPC_admin) {
      setToken(localStorage.getItem("token_GPC_admin"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      const res = await Instance.get(
        `/api/v1/getAdminListTenantArchive`,
        config
      );
      if (res.data.status === true) {
        dispatch({
          type: actions.GET_ALL_TENANTS_CONTRACTS_DELETE,
          payload: res.data.data,
          tenant_delete_status: true,
        });
      }
    } catch (error) {}
  };
};
export const Delete_List_All_Paradan = () => {
  return async (dispatch) => {
    if (localStorage.token_GPC_admin) {
      setToken(localStorage.getItem("token_GPC_admin"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      const res = await Instance.get(`/api/v1/paradndeleted`, config);
      if (res.data.status === true) {
        dispatch({
          type: actions.GET_ALL_PARADAN_DELETE,
          payload: res.data.data,
          P_delete_status: true,
        });
      }
    } catch (error) {}
  };
};
export const Delete_List_All_TakeMoney = () => {
  return async (dispatch) => {
    if (localStorage.token_GPC_admin) {
      setToken(localStorage.getItem("token_GPC_admin"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      const res = await Instance.get(`/api/v1/wasldeleted`, config);
      if (res.data.status === true) {
        dispatch({
          type: actions.GET_ALL_TAKEMONEY_DELETE,
          payload: res.data.data,
          T_delete_status: true,
        });
      }
    } catch (error) {}
  };
};

export const Tenant_Active_Status = (id) => {
  return async (dispatch) => {
    if (localStorage.token_GPC_admin) {
      setToken(localStorage.getItem("token_GPC_admin"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      await Instance.put(`/api/v1/ReActivateTenant/${id}`, config);
      dispatch({ type: actions.ACTIVATE_TENANT, rent_id: id });
    } catch (error) {}
  };
};
